@if (model) {
	@if (isMobile) {
		<img
			[src]="model.mobileImg"
			(click)="changeLanguage()"
			class="cursor-pointer language-icon"
			alt="language"
			loading="eager"
			decoding="async" />
	} @else {
		<div class="d-flex">
			<img
				[class.pe-none]="model.language === accountLanguage.German"
				[src]="model.desktopDeImg"
				(click)="changeLanguage()"
				class="cursor-pointer language-icon"
				alt="de language"
				loading="eager"
				decoding="async" />
			<img src="assets/orca/header/language_separator.svg" class="seperator" alt="seperator" loading="eager" decoding="async" />
			<img
				[class.pe-none]="model.language === accountLanguage.English"
				[src]="model.desktopEnImg"
				(click)="changeLanguage()"
				class="cursor-pointer language-icon"
				alt="en language"
				loading="eager"
				decoding="async" />
		</div>
	}
}
